<template>
    <div>
        <section class="headband">
          <div class="container-fluid fl-max">
            Enter by July 9th, 2020
          </div>
        </section>
        <section class="top-header-cont">
          <div class="top-header">
            <div class="brand-overlay">
              <div class="container-fluid fl-max">
                <div class="brands">
                  <div class="brand-retailer">
                    <img class="retailer" src="@/assets/images/main/sleep-outfitters-logo.png">
                  </div>
                  <div class="brand-product">
                    <img class="product" src="@/assets/images/main/tempurpedic-logo-lg.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid fl-max">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="top-header__content">
                          <div class="copy-1">HOW WAS YOUR EXPERIENCE?</div>
                          <div class="copy-2">We'd love<br>to hear your<br>thoughts.</div>
                          <div class="copy-3">Tell us about your store visit, and then write a Tempur-Pedic product review for two chances to win a free Tempur-Pedic mattress set.* Follow the steps below to automatically be entered.</div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </section>

        <section class="icon-subheader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 step-icon-cont step-1">
                        <div class="step-icon"><img src="@/assets/images/main/step-icon-1.png"></div>
                        <div class="step-copy">
                          <h3>1. STORE REVIEW</h3>
                          <p>To begin, select your store to choose your retail location. You'll automatically be taken to the Google store review page.</p>
                        </div>
                    </div>
                    <div class="col-sm-4 step-icon-cont step-2">
                        <div class="step-icon"><img src="@/assets/images/main/step-icon-2.png"></div>
                        <div class="step-copy">
                          <h3>2. TEMPUR-PEDIC REVIEW</h3>
                          <p>After submitting your Google store review, return to this page to complete the product review section for a second entry.</p>
                        </div>
                    </div>
                    <div class="col-sm-4 step-icon-cont step-3">
                        <div class="step-icon"><img src="@/assets/images/main/step-icon-3.png"></div>
                        <div class="step-copy">
                          <h3>SUCCESS!</h3>
                          <p>You're now entered for two chances to win a free Tempur-Pedic mattress set!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="enter-main">
            <div class="container">
                <form id="entry-form" name="entry-form" v-on:submit.prevent autocomplete="off">

                  <div class="subsection">

                    <!-- About You -->
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="enter-main__header-content">
                                <h2>Entry 1: Submit a store experience review.</h2>
                            </div>
                        </div>
                    </div>

                    <!-- nameF nameL -->
                    <div class="row justify-content-center">
                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-nameF">First Name</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.nameF.$error, 'form-validation-success': !$v.entryFormData.nameF.$invalid && $v.entryFormData.nameF.$dirty }">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="entryFormData-nameF"
                                    name="entryFormData-nameF"
                                    aria-describedby="entryFormData-nameF-help"
                                    v-model.trim="entryFormData.nameF"
                                    @input="(!$v.entryFormData.nameF.$invalid) ? $v.entryFormData.nameF.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.nameF.$error">Please enter your first name.</div>
                            <div class="sr-only" id="entryFormData-nameF-help">Please enter your first name.</div>
                        </div>

                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-nameL">Last Name</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.nameL.$error, 'form-validation-success': !$v.entryFormData.nameL.$invalid && $v.entryFormData.nameL.$dirty }">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="entryFormData-nameL"
                                    name="entryFormData-nameL"
                                    aria-describedby="entryFormData-nameL-help"
                                    v-model.trim="entryFormData.nameL"
                                    @input="(!$v.entryFormData.nameL.$invalid) ? $v.entryFormData.nameL.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.nameL.$error">Please enter your last name.</div>
                            <div class="sr-only" id="entryFormData-nameL-help">Please enter your last name.</div>
                        </div>
                    </div>

                    <!-- email location -->
                    <div class="row justify-content-center">
                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-email">Email</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.email.$error, 'form-validation-success': !$v.entryFormData.email.$invalid && $v.entryFormData.email.$dirty }">
                                <input
                                    type="email"
                                    class="form-control"
                                    id="entryFormData-email"
                                    name="entryFormData-email"
                                    aria-describedby="entryFormData-email-help"
                                    v-model.trim="entryFormData.email"
                                    @input="(!$v.entryFormData.email.$invalid) ? $v.entryFormData.email.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-message">We need this to contact you if you win the sweepstakes! (Your email will not be displayed on the review page.)</div>
                            <div class="form-validation-message" v-if="$v.entryFormData.email.$error">Please enter a valid email address.</div>
                            <div class="sr-only" id="entryFormData-email-help">Please enter a valid email address.</div>
                        </div>
                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-location">Location</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.location.$error, 'form-validation-success': !$v.entryFormData.location.$invalid && $v.entryFormData.location.$dirty }">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="entryFormData-location"
                                    name="entryFormData-location"
                                    placeholder="Example: Boston, MA"
                                    aria-describedby="entryFormData-location-help"
                                    v-model.trim="entryFormData.location"
                                    @input="(!$v.entryFormData.location.$invalid) ? $v.entryFormData.location.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.location.$error">Please enter your location.</div>
                            <div class="sr-only" id="entryFormData-location-help">Please enter your location.</div>
                        </div>
                    </div>
                  </div>

                  <div class="subsection">

                    <!-- store -->
                    <div class="row justify-content-center">
                       <div class="col-lg-10">
                           <multiple-chained-select class="py-4"></multiple-chained-select>
                       </div>

                        <div class="col-lg-10">
                            <div class="form-validation-message" v-if="$v.selectedStore.$error">Please choose a store from the dropdown.</div>
                        </div>
                    </div>

                    <!-- hr -->
                    <div class="row justify-content-center"><div class="col-lg-10"><hr></div></div>
                  </div>
                  <div class="subsection">
                    <!-- Your Review -->
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="enter-main__note">
                                <font-awesome-icon :icon="['fas', 'star']" class="fa fa-fw icon-star" /> Completed the Google store review? Don't forget this section for a second entry!
                            </div>
                        </div>
                    </div>


                    <!-- Your Mattress -->
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="enter-main__header-content">
                                <h2>Entry 2: Tell us about your Tempur-Pedic mattress.</h2>
                            </div>
                        </div>
                    </div>

                    <!-- model dateOfPurchase -->

                    <div class="row justify-content-center">
                        <div class="col-lg-5 input-group-wrapper">
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.mattressModelObject.$error, 'form-validation-success': !$v.entryFormData.mattressModelObject.$invalid && $v.entryFormData.mattressModelObject.$dirty }">
                                <select
                                    class="form-control"
                                    id="entryFormData-mattressModel"
                                    name="entryFormData-mattressModel"
                                    aria-describedby="entryFormData-mattressModel-help"
                                    v-model.trim="entryFormData.mattressModelObject"
                                    @change="(!$v.entryFormData.mattressModelObject.$invalid) ? $v.entryFormData.mattressModelObject.$touch() : ''">
                                    <option value="">Select your Tempur-Pedic mattress</option>
                                    <option
                                        v-for="(mattress, index) in mattressModels"
                                        :value="mattress"
                                        :key="index"
                                        v-if="mattress.pageId"
                                        :label="mattress.name">
                                        {{mattress.name}}
                                    </option>
                                </select>
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.mattressModelObject.$error">Please select a mattress model.</div>
                            <div class="sr-only" id="entryFormData-mattressModel-help">Please select a mattress model.</div>
                        </div>
                        <div class="col-lg-5 input-group-wrapper"></div>
                    </div>

                    <!-- rating -->
                    <div class="row justify-content-center">
                        <div class="col-lg-4 input-group-wrapper">
                            <label>Overall Rating</label>
                            <star-rating
                                v-model="entryFormData.rating"
                                active-color="#C6A390"
                                :show-rating="(entryFormData.rating !== 0) ? true : false"
                                :rounded-corners="true"
                                :star-points="[23,2, 15,18, 0,19, 11,33, 7,50, 23,42, 38,50, 35,33, 46,19, 30,18]"
                            ></star-rating>
                            <div class="form-validation-message" v-if="$v.entryFormData.rating.$error">Please choose a rating.</div>
                        </div>
                        <div class="col-lg-6"></div>
                    </div>

                    <!-- nickname headline -->
                    <div class="row justify-content-center">
                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-nickname">Nickname</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.nickname.$error, 'form-validation-success': !$v.entryFormData.nickname.$invalid && $v.entryFormData.nickname.$dirty }">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="entryFormData-nickname"
                                    name="entryFormData-nickname"
                                    aria-describedby="entryFormData-nickname-help"
                                    placeholder="Example: Happy Sleeper"
                                    v-model.trim="entryFormData.nickname"
                                    @input="(!$v.entryFormData.nickname.$invalid) ? $v.entryFormData.nickname.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.nickname.$error">Please enter your nickname.</div>
                            <div class="sr-only" id="entryFormData-nickname-help">Please enter your nickname.</div>
                        </div>

                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-headline">Review Headline</label>
                            <div class="input-group" v-bind:class="{ 'form-validation-error': $v.entryFormData.headline.$error, 'form-validation-success': !$v.entryFormData.headline.$invalid && $v.entryFormData.headline.$dirty }">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="entryFormData-headline"
                                    name="entryFormData-headline"
                                    placeholder="Ex. Comfortable Premium Product"
                                    aria-describedby="entryFormData-headline-help"
                                    v-model.trim="entryFormData.headline"
                                    @input="(!$v.entryFormData.headline.$invalid) ? $v.entryFormData.headline.$touch() : ''"
                                >
                                <div class="input-group-append"><span class="input-group-text validation-symbol"></span></div>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.headline.$error">Please enter your review headline.</div>
                            <div class="sr-only" id="entryFormData-headline-help">Please enter your review headline.</div>
                        </div>
                    </div>

                    <!-- wouldRecommend -->
                    <div class="row justify-content-center">
                        <div class="col-lg-5 input-group-wrapper">
                            <label for="entryFormData-comments">Describe your experience with the product</label>
                            <div class="small">The most useful comments contain specific information about:</div>
                            <ul class="small">
                                <li>How this product has changed your life</li>
                                <li>Things you love about it</li>
                                <li>What others should know about it</li>
                            </ul>
                        </div>

                        <div class="col-lg-5 input-group-wrapper">
                            <label>Would you recommend this product?</label>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="entryFormData-recommendRadios"
                                    id="entryFormData-recommendRadiosYes"
                                    value="Yes"
                                    v-model="entryFormData.wouldRecommend">
                                <label for="entryFormData-recommendRadiosYes">
                                    Yes, I <i>would</i> recommend this product.
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="entryFormData-recommendRadios"
                                    id="entryFormData-recommendRadiosNo"
                                    value="No"
                                    v-model="entryFormData.wouldRecommend">
                                <label for="entryFormData-recommendRadiosNo">
                                    No, I <i>would not</i> recommend this product.
                                </label>
                            </div>
                            <div class="form-validation-message" v-if="$v.entryFormData.wouldRecommend.$error">Please choose an option.</div>
                        </div>
                    </div>

                    <!-- comments -->
                    <div class="row justify-content-center">
                        <div class="col-lg-10 input-group-wrapper" v-bind:class="{ 'form-validation-error': $v.entryFormData.comments.$error, 'form-validation-success': !$v.entryFormData.comments.$invalid && $v.entryFormData.comments.$dirty }">
                            <textarea
                                id="entryFormData-comments"
                                name="entryFormData-comments"
                                aria-describedby="entryFormData-comments"
                                class="form-control"
                                v-model.trim="entryFormData.comments"
                                placeholder="Describe your experience with the product..."
                                @input="(!$v.entryFormData.comments.$invalid) ? $v.entryFormData.comments.$touch() : ''"
                            ></textarea>
                            <div class="form-validation-message" v-if="$v.entryFormData.comments.$error">Please describe your experience with the product.</div>
                            <div class="sr-only" id="entryFormData-comments-help">Describe your experience with the product...</div>
                            <div class="small text-muted mt-3">
                                Please do not include: HTML, references to other retailers, pricing, personal information, or any profane, inflammatory or copyrighted comments. A badge or text with your review will indicate that it has been collected in conjunction with a sweepstakes.
                            </div>
                        </div>
                    </div>

                    <!-- hr -->
                    <div class="row justify-content-center"><div class="col-lg-10"><hr></div></div>
                  </div>
                  <div class="subsection">

                    <!-- submit -->
                    <div class="row justify-content-center mt-4">
                        <div class="col-lg-8 text-center">
                            <button @click.prevent="submit" :disabled="pending" id="entryFormData-submit" class="btn btn-tan btn-lg">
                                <span v-if="!pending">
                                    Submit
                                </span>

                                <span v-if="pending">
                                    <font-awesome-icon :icon="['fal', 'cog']" spin class="fa fa-fw" /> Submit
                                </span>
                            </button>
                        </div>
                    </div>

                    <!-- text -->
                    <div class="row justify-content-center mt-4">
                        <div class="col-lg-8 text-center small text-muted">
                            <p>The nickname you choose, not your email, will be displayed on the website. We will only use this if we have questions about your review or for contacting you regarding sweepstakes matters.</p>

                            <p>By submitting, I agree with the <a href="https://www.powerreviews.com/legal/privacy_policy_en_US.html" target="_blank">Privacy Policy</a> and that I am age 18 or older.</p>
                        </div>
                    </div>
                  </div>
                </form>
            </div>
        </section>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, minValue } from 'vuelidate/lib/validators'
//import tsiMattressSerialRegex from '@/common/tsiMattressSerialRegex'
//import zipCodeRegex from '@/common/zipCodeRegex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import StarRating from 'vue-star-rating'

export default {
    name: 'home',
    data () {
        return {
            hasShownAnimation: false,
            pending: false,
            entryFormData: {
                nameF: '',
                nameL: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                email: '',
                mattressModelObject: '',
                mattressModelPageId: '',
                mattressModelPageIdVariant: '',
                mattressModelName: '',
                dateOfPurchase: '',
                serialNumber: '',
                location: '',
                storeObject: null,
                storeId: '',
                storeInfo: '',
                storeCity: '',
                storeState: '',
                rating: 0,
                headline: '',
                comments: '',
                nickname: '',
                wouldRecommend: null,
                optCommunication: true
            },
            fpConfig: {
                wrap: true, // set wrap to true when using 'input-group'
                altInput: true,
                maxDate: new Date((new Date()).getTime() + (24 * 60 * 60 * 500))
            },
        }
    },
    watch: {
        product(newValue) {
            // reset models when product changes
            this.models = ''
        }
    },
    computed: {
        ...mapGetters({
            mattressModels: 'models/mattressModels',
            selectedStore: 'multipleChainedSelect/selectedStore',
            placeId: 'multipleChainedSelect/placeId'
        })
    },
    methods: {
        async submit () {
            if (this.$v.$invalid) {
                this.$v.$touch()
                this.$toasted.error('Please complete all fields.')
                return
            }

            // Set multipleChainedSelect selectedStore to the form's store
            this.entryFormData.storeObject = this.selectedStore
            this.entryFormData.storeId = this.selectedStore.id
            this.entryFormData.storeInfo = this.selectedStore.name + ' ' + this.selectedStore.address
            this.entryFormData.storeCity = this.selectedStore.city
            this.entryFormData.storeState = this.selectedStore.state

            // Set our mattressModel name, pageId, and pageIdVariant
            this.entryFormData.mattressModelPageId = this.entryFormData.mattressModelObject.pageId
            this.entryFormData.mattressModelPageIdVariant = this.entryFormData.mattressModelObject.pageIdVariant
            this.entryFormData.mattressModelName = this.entryFormData.mattressModelObject.name

            this.pending = true

            this.entryFormData.entry_type = 'product-review'

            try {
                await this.$store.dispatch('enter/enter', this.entryFormData)
                this.$v.$reset()

                this.entryFormData = {
                    nameF: '',
                    nameL: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                    email: '',
                    mattressModelObject: '',
                    mattressModelPageId: '',
                    mattressModelPageIdVariant: '',
                    mattressModelName: '',
                    dateOfPurchase: '',
                    serialNumber: '',
                    location: '',
                    storeObject: null,
                    storeId: '',
                    storeInfo: '',
                    storeCity: '',
                    storeState: '',
                    rating: 0,
                    headline: '',
                    comments: '',
                    nickname: '',
                    wouldRecommend: null,
                    optCommunication: false
                }

                // Reset store picker
                this.$store.dispatch('multipleChainedSelect/reset')

                this.$root.$emit('showEnterSuccessModal')
                // this.$ga.event('Enter', 'Submit', 'Success')
            } catch (error) {
                if (!error.message) {
                    this.$toasted.error('There was an error connecting to the server. Please try again.')
                } else if (error.message === 'DUPLICATE_ENTRY') {
                    this.$toasted.error('Thank you, your review has already been collected.')
                }  else if (error.message === 'INVALID_SERIAL') {
                    this.$toasted.error('Sorry, but that serial number does not seem valid. Please check your serial number and try again.', {
                        duration: 6000
                    })
                } else {
                    this.$toasted.error(error.message+'There was an error connecting to the server. Please try again. :(')
                }

                // this.$ga.event('Enter', 'Submit', 'Error')
            } finally {
                this.pending = false
            }
        },

        topHeaderAnimation () {
            // Animation for top-header
            let timeline = this.$animejs.timeline()
            timeline
                .add({
                    duration: 0,
                    opacity: 0,
                    translateY: 30,
                    targets: '.top-header__content, .icon-subheader',
                    easing: 'easeInOutCubic',
                })
                .add({
                    duration: 1000,
                    opacity: 1,
                    translateY: 0,
                    targets: '.top-header__content, .icon-subheader',
                    easing: 'easeInOutCubic',
                })

            this.hasShownAnimation = true
        }
    },
    mounted () {
        this.topHeaderAnimation()
    },
    validations: {
        entryFormData: {
            nameF: {
                required
            },
            nameL: {
                required
            },
            email: {
                required,
                email
            },
            mattressModelObject: {
                required
            },
            location: {
                required
            },
            rating: {
                minValue: minValue(1)
            },
            headline: {
                required
            },
            comments: {
                required
            },
            nickname: {
                required
            },
            wouldRecommend: {
                required
            }
        },
        selectedStore: {
            required
        }
    },
    components: {
        Multiselect,
        StarRating,
    },
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .fl-max {
      max-width: 1400px;

      @media (min-width: 775px) {
        padding-right: 50px;
        padding-left: 50px;
      }
    }

    .headband {
      background-color: #323E49;
      text-align: right;
      color: #fff;
      padding: 15px 0;
    }
    .top-header-cont {
      position: relative;
      background-color: #323E49;
      background-image:url('~@/assets/images/main/tempur-pedic-win-a-free-mattress-set.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding: 0;
      margin: 0;
      height: auto;

      .top-header {
          background: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 30%);

          @media (min-width: 1024px) {

          }

          &__content {
            color: #fff;
            padding: 80px 0;
            position: relative;
            opacity: 0;

            .copy-1 {
              font-family: "din-2014", sans-serif;
              font-size: 16px;
              letter-spacing: 2px;
            }
            .copy-2 {
              font-size: 40px;
              font-weight: 500;
              line-height: 0.76;
              padding: 20px 0;
              font-family: "mrs-eaves-roman-all-small-ca", sans-serif;
            }

            .copy-3 {
              max-width: 520px;
              font-family: "din-2014", sans-serif;
              font-size: 16px;
              line-height: 1.3;
            }

            @media(min-width: 500px) {
              .copy-1 {
                font-size: 18px;
                letter-spacing: 2.5px;
              }
              .copy-2 {
                font-size: 60px;
              }
              .copy-3 {
                font-size: 20px;
              }
            }

            @media(min-width: 992px) {
              .copy-1 {
                font-size: 22.5px;
                letter-spacing: 3px;
              }
              .copy-2 {
                font-size: 84px;
              }
              .copy-3 {
                font-size: 24px;
              }
            }
          }

          .brand-overlay {
            background: rgba(255,255,255,0.8);
            padding: 20px 0;

            .brands {
              vertical-align: top;
              display: flex;

              .brand-retailer {
                width: 50%;
                text-align: left;

                img {
                  height: 20vw;
                  max-height: 80px;
                }
              }
              .brand-product {
                width: 50%;
                text-align: right;

                img {
                  height: 10vw;
                  max-height: 50px;
                  margin-top: 5vw;
                  vertical-align: baseline;
                  @media(min-width: 490px) {
                    margin-top: 25px;
                  }
                }
              }

            }
          }
      }
    }

    .top-subheader {
        padding: 50px 0;
        font-size: 1.8rem;
        line-height: 1.3;
        text-transform: uppercase;
        text-align: center;
        font-weight: 300;

        @media(min-width: 992px) {
            font-size: 2.6rem;
        }
    }

    .enter-main {
        padding: 80px 0;

        &__header-content {
            position: relative;

            &__header {
                font-size: 1.7rem;
                text-transform: uppercase;
                margin-bottom: 20px;
                color: $black;
            }

            .step-num {
              position: absolute;
              left: -80px;
              top: -12px;
            }
        }

        &__note {

          padding-bottom: 20px;
          font-weight: 700;

          .icon-star {
            color: #C6A390
          }
        }

        ul {
            padding-left: 25px;
        }
    }

    @keyframes animateTopHeaderBackgroundOpacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 0.85;
        }
    }
</style>
